"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const create_icon_1 = require("../utils/create-icon");
exports.CloseIcon = (0, create_icon_1.createIcon)({
    displayName: "Close",
    path: ((0, jsx_runtime_1.jsx)("polygon", { fill: "currentColor", points: "12.16 11.46 22.92 22.22 22.22 22.92 11.46 12.16 .7 22.92 0 22.22 10.76 11.46 0 .7 .7 0 11.46 10.76 22.22 0 22.92 .7 12.16 11.46" })),
});
